module.exports = __webpack_public_path__ + "insa-report/web/locale/locale.properties";


//////////////////
// WEBPACK FOOTER
// ./app/insa-report/web/locale/locale.properties
// module id = 970
// module chunks = 3